import moment from 'moment'

// Chart.js v4 passes the click handler (event, activeElements, chart).
// Each active element is { datasetIndex, index, element } — the old v2
// `_model`/`_index` shape no longer exists, so drill-down clicks were
// silently ignored. Read the point index from the element and resolve the
// label from the chart's own data.
const getClickedIndex = (elements) => {
  if (!Array.isArray(elements) || elements.length === 0) {
    return null
  }
  const { index } = elements[0] ?? {}
  return typeof index === 'number' ? index : null
}

const getLabelAt = (chart, index) => {
  const rawLabel = chart?.data?.labels?.[index]
  return Array.isArray(rawLabel) ? rawLabel.join(' ') : rawLabel
}

export const createGraphNodeClicker = (data = [], onClick) => (_, elements, chart) => {
  if (!data) {
    console.log(`Warning no data supplied to graph node clicker`) // eslint-disable-line
    return
  }

  const index = getClickedIndex(elements)
  if (index === null || !data[index]) {
    return
  }

  const date = data[index]
  const label = getLabelAt(chart, index)
  const key = 'range' //index === 0 ? 'status' : 'range'

  switch (label) {
    case 'Matured':
    case 'Expired':
    case 'Overdue':
      onClick(null, null)
      return
    default:
      break
  }

  try {
    const dateMoment = moment(date).utc()
      .date(1)
    if (dateMoment.isValid()) {
      let formattedValue = dateMoment.format('MMMM YYYY')
      onClick(key, formattedValue)
    } else {
      onClick(key, label)
    }
  }
  catch (err) {
    console.log('Error parsing date', err.message) // eslint-disable-line
  }
}

export const createBasicGraphNodeClicker = (onClick) => (_, elements, chart) => {
  const index = getClickedIndex(elements)
  if (index === null) {
    return
  }

  const label = getLabelAt(chart, index)
  if (label === undefined || label === null) {
    return
  }

  onClick(label)
}

export const createStackedBarGraphNodeClicker = (data = [], onClick) => (_, elements, chart) => {
  if (!data) {
    console.log(`Warning no data supplied to graph node clicker`) // eslint-disable-line
    return
  }

  const index = getClickedIndex(elements)
  if (index === null || !data[index]) {
    return
  }

  const date = data[index]
  const label = getLabelAt(chart, index)
  const key = 'range' //index === 0 ? 'status' : 'range'

  switch (label) {
    case 'Matured':
    case 'Expired':
    case 'Overdue':
      onClick(null, null)
      return
    default:
      break
  }

  try {
    const dateMoment = moment(date).utc()
      .date(1)
    if (dateMoment.isValid()) {
      let formattedValue = dateMoment.format('MMMM YYYY')
      onClick(key, formattedValue)
    } else {
      onClick(key, label)
    }
  }
  catch (err) {
    console.log('Error parsing date', err.message) // eslint-disable-line
  }
}
